<!--  -->
<template>
  <div v-if="finished">
    <img style="width: 100%" src="@/../static/img/jobs.png" alt="" />
    <h3 class="title">加入我们</h3>
    <div>JOIN US</div>
    <el-table
      @expand-change="expandSelect"
      @row-click="rowClick"
      :row-key="getRowKeys"
      align="center"
      :header-cell-style="{
        background: '#F3F4F7',
        color: '#555',
        textAlign: 'center',
      }"
      :cell-style="{ textAlign: 'center' }"
      :expand-row-keys="expands"
      :data="tableData"
      class="eltable"
      style="width: 90%; margin: 30px auto"
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-form-item label="岗位职责">
              <div v-for="item in props.row.responsibilities" :key="item">
                {{ item }}
              </div>
            </el-form-item>
            <el-form-item label="岗位要求">
              <div v-for="item in props.row.requirements" :key="item">
                {{ item }}
              </div>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column label="职位" prop="position"> </el-table-column>
      <el-table-column label="薪资" prop="salary"> </el-table-column>
      <el-table-column label="经验要求" prop="Experience"> </el-table-column>
      <!-- <el-table-column label="工作地点" prop="workingPlace"> </el-table-column> -->
    </el-table>
  </div>
</template>

<script>
let imgArr = [require("@/../static/img/jobs.jpg")];

export default {
  data() {
    return {
      finished: false,
      expands: [],

      tableData: [
        {
          position: "医疗售前",
          salary: "8k-16K",
          Experience: "1-3年",
          education: "大专",
          NatureJob: "全职",
          workingPlace: "深圳",
          responsibilities: [
            "1、负责售前技术支持工作，包括客户调研、需求分析、技术方案的规划和设计、讲解等。",
            "2、与客户进行沟通，了解关键的技术或业务需求，提出相应的解决方案。",
            "3、维护客户关系、解答客户咨询、制定方案计划、协同完成团队目标。",
            "4、配合销售人员完成招投标标书编写。",
            "5、具有比较全面技术专业知识，不断学习新知识，创新能力，熟悉当前医疗IT的技术发展方向。",
          ],
          requirements: [
            "1、医学影像学、计算机等相关专业大专以上学历，3年以上工作经验。",
            "2、熟悉医疗卫生信息化行业，精通医疗业务流程，承担过医疗卫生信息化、移动医疗、互联网医疗, 尤其医学影像等相关项目的优先考虑。",
            "3、具有良好的沟通能力，文档能力及演讲能力，较强的逻辑思维能力，较强的抗压能力。",
          ],
        },
        {
          position: "医疗销售",
          salary: "5k-8K",
          Experience: "1-3年",
          education: "不限",
          NatureJob: "全职",
          workingPlace: "深圳",
          responsibilities: [
            "1、完成公司制定的年度销售、运营计划。",
            "2、负责医院、经销商的开发及管理。",
            "3、负责医院的日常维护。",
            "4、负责区域内市场的维护和开发，并反馈市场信息为公司重大经营决策提供有效信息。",
            "5、完成公司根据需要安排的其他工作。",
          ],
          requirements: [
            "1、有一定的医疗行业销售、运营工作经验，医学影像专业优先，放射产品或者PACS、HIS等销售运营经验优先。",
            "2、良好的沟通和表达能力。",
            "3、能够经常出差。",
          ],
        },
        {
          position: "产品经理/高级产品经理",
          salary: "15k-25k",
          Experience: "3-5年",
          education: "本科",
          NatureJob: "全职",
          workingPlace: "深圳",
          responsibilities: [
            "1、了解医疗相关政策法规、掌握互联网医疗行业市场发展动态、挖掘互联网医疗行业市场需求，引领公司互联网医疗产品发展方向。",
            "2、规划互联网医疗产品原型设计和落地，并热衷于持续优化和迭代。",
            "3、对互联网医疗产品进行需求分析，产出PRD和DEMO等产品需求定义，与技术开发团队密切配合，按期保质完成项目上线。",
            "4、持续改善产品功能，从用户体验，增长留存角度出发，能通过数据分析，提出产品方案。",
            "5、跟进产品的设计、开发、测试、上线、运营全过程，对产品进度和质量负责，并确保产品上线运营。",
            "6、协调各部门共同配合完成解读应用的开发，控制开发进度及质量，并对成果进行验收。",
          ],
          requirements: [
            "1、本科及以上学历，五年以上产品工作经验，三年以上互联网医疗产品的工作经验。",
            "2、了解产品生命周期，有产品从0-1的经验，熟悉互联网产品设计工具，熟练掌握Axure，MindManager，Visio/Project等。",
            "3、具备较强的逻辑思维能力，优秀的沟通能力和执行力，工作责任心强，能承受较大的工作压力，看重结果导向。",
          ],
        },
        {
          position: "渠道总监",
          salary: "10k-20k",
          Experience: "5-8年",
          education: "不限",
          NatureJob: "全职",
          workingPlace: "深圳",
          responsibilities: [
            "1、负责公司产品在各省区招商推广工作。",
            "2、负责代理商的开发和产品销售目标的分解实施，确保各项任务的完成。",
            "3、负责市场信息调研工作，对目标市场进行资源管理，形成有效控制和合理分配。",
            "4、协助公司处理市场突发事件，提出解决方案。",
            "5、协助和安排市场部在各省的各项产品推广活动。",
            "6、认真、高效的执行公司下发的各项管理措施。",
            "7、对政策、市场高度敏感，及时有效规避风险。",
          ],
          requirements: [
            "1、医学、药学，市场营销等相关专业，本科以上学历，熟悉销售、招商、物价等市场营销工作内容，有卫计，医院，医药渠道等资源。",
            "2、5-8年以上医疗信息化、医疗器械等医疗行业销售管理经验，如有医学影像销售经验佳。",
            "3、对医学影像，互联网+医疗市场有较好的理解和把握，良好的专业知识和销售技巧。",
            "4、诚信、勤奋、敬业，抗压力强，具备业务计划和独立分析问题能力。",
            "5、有一定管理团队的经验。",
          ],
        },
        {
          position: "区域经理（全国）",
          salary: "10K-18K",
          Experience: "不限",
          education: "不限",
          NatureJob: "全职",
          workingPlace: "不限",
          responsibilities: [
            "1、开发医疗项目、拓展医疗市场，完成公司制定的年度销售任务。",
            "2、负责区域内整体规划和市场布局，并反馈市场信息为公司重大经营决策提供有效信息。",
            "3、完成公司根据需要安排的其他工作。",
          ],
          requirements: [
            "1、医学影像专业优先，放射产品或者PACS、HIS等销售经验3年以上。",
            "2、大型医疗器械背景，或省级药品招商经理背景。",
            "3、良好的沟通和表达能力。",
            "4、能够经常出差。",
          ],
        },
      ],
    };
  },

  components: {},

  computed: {},

  mounted() {
    this.preload(imgArr).then((res) => {
      this.finished = true;
    });
  },

  methods: {
    getRowKeys(row) {
      return row.position;
    },
    expandSelect(row, expandedRows) {
      console.log("expandedRows", expandedRows);
      console.log("row", row);
      var that = this;
      if (expandedRows.length) {
        that.expands = [];
        if (row) {
          that.expands.push(row.position); // 每次push进去的是每行的ID
        }
      } else {
        that.expands = []; // 默认不展开
      }
    },

    headerStyle() {},
    preload(imgArr) {
      let pa = [];
      imgArr.forEach((n) => {
        pa.push(
          new Promise(async (resolve, reject) => {
            let myImage = new Image();
            myImage.src = n;
            myImage.onload = function () {
              resolve();
            };
            myImage.onerror = function () {
              resolve();
            };
          })
        );
      });
      return Promise.all(pa);
    },

    rowClick(row) {
      console.log(this.expands, "this.expands");
      if (this.expands.length > 0) {
        if (this.expands.indexOf(row.position) < 0) {
          this.expands = [];
          this.expands.push(row.position);
        } else {
          this.expands.splice(row.position, 1);
        }
      } else {
        this.expands.push(row.position);
      }
    },
  },
};
</script>
<style rel='stylesheet/less' lang='less' scoped>
.title {
  margin-top: 60px;
  color: #464c4f;
  font-size: 30px;
}
.eltable /deep/ .el-form-item__content {
  line-height: 20px;
}
.eltable /deep/ .el-table__expanded-cell {
  padding: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/jobs.vue